/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Illegal_Chars_LabelInputs */



/**
* | output |
* | --- |
* | "Detect Illegal Chararacters (608)" |
*
* @param {Edit_Event_Group_Illegal_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_illegal_chars_label = /** @type {((inputs?: Edit_Event_Group_Illegal_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Illegal_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détecter les caractères illégaux (608)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Illegale Zeichen erkennen (608)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rileva caratteri illegali (608)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выявление недопустимых символов (608)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectar personajes ilegales (608)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测非法字符 (608)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不正な文字を検出する (608)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अवैध वर्णों का पता लगाना (608)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectar caracteres ilegais (608)")
	return /** @type {LocalizedString} */ ("Detect Illegal Chararacters (608)")
});